import * as THREE from 'three';

/**
 * Combined world-space bounds of several objects.
 *
 * Box3.expandByObject refreshes matrixWorld for each object's own subtree as
 * it walks down, but never walks up — same gap commands.js's focusObject was
 * fixed for. Refresh each object's ancestor chain first so a parent moved
 * right before this call (no render in between) doesn't leave the bounds
 * pointed at a stale world transform.
 */
function refreshedBounds(objects) {
  const bounds = new THREE.Box3();
  for (const object of objects) {
    object.updateWorldMatrix(true, false);
    bounds.expandByObject(object);
  }
  return bounds;
}

/** Center of several objects' combined world-space bounds, ancestor-fresh. */
export function objectsBoundsCenter(objects) {
  return refreshedBounds(objects).getCenter(new THREE.Vector3());
}

/**
 * Point the camera/controls at the combined bounds of several objects.
 *
 * Extracted out of main.js's multi-select frameSelection() so this math is
 * unit-testable without a DOM (main.js runs document.getElementById() at
 * module load and can't be imported under plain Node). Behavior is otherwise
 * unchanged from the code this replaced.
 */
export function frameObjectsBounds({ objects, camera, controls, padding = 1.8 }) {
  const bounds = refreshedBounds(objects);
  const center = bounds.getCenter(new THREE.Vector3());
  const distance = Math.max(bounds.getSize(new THREE.Vector3()).length(), 1) * padding;
  const direction = camera.position.clone().sub(controls.target).normalize();
  controls.target.copy(center);
  camera.position.copy(center).add(direction.multiplyScalar(distance));
  controls.update();
}
